<template>
<el-card class="box-card" shadow="hover">
  <div slot="header" class="clearfix" style="position:relative">
    <el-breadcrumb>
      <el-breadcrumb-item :to="{ path: 'goodsList' }">物料列表</el-breadcrumb-item>
      <el-breadcrumb-item>编辑物料</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <div class="text item">
    <el-form ref="form" :model="form" label-width="160px">
        <el-form-item label="物料编码">
          {{form.gcode}}
        </el-form-item>
        <el-form-item label="客户物料编码">
          <el-input v-model="form.cgcode" maxlength="100" placeholder="请输入客户物料编码" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="物料名称" :required="true">
          <el-input v-model="form.title" placeholder="请输入物料名称" maxlength="100" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="物料描述/规格">
          <el-input type="textarea" v-model="form.remark" maxlength="250" show-word-limit></el-input>
        </el-form-item>
        <el-form ref="form" inline :model="form" label-width="160px">
          <el-form-item label="单价（含税）" :required="true">
            <el-input-number v-model="form.price" :precision="4" :step="0.1" :min="0.00"></el-input-number>
          </el-form-item>
          <el-form-item label="单位" :required="true">
            <el-input v-model="form.unit" maxlength="50" show-word-limit></el-input>
          </el-form-item>
        </el-form>
        <el-form-item label="税率" :required="true">
          <el-input v-model="form.taxRate" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <!-- <el-form ref="form" inline :model="form" label-width="160px">
          <el-form-item label="分配权比例" :required="true">
            <el-input v-model="form.scale" placeholder="比如20:80" maxlength="50" show-word-limit></el-input>
          </el-form-item>
        </el-form> -->
        <el-form ref="form" inline :model="form" label-width="160px" v-show="showBtn<1||showBtn==3">
          <el-form-item label="分配比例" :required="true">
            <el-input-number v-model="form.scale" :min="0" :max="100"></el-input-number><span style="margin-left:10px">%</span>
            <span v-show="form.gcode" style="margin-left:30px;color:red">剩余分配比例{{form.surplus}}%</span>
          </el-form-item>
        </el-form>
        <el-form-item label="价格有效期" :required="true">
          <el-date-picker
            v-model="form.validityTime"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="凭证">
          <el-upload
            class="upload-demo"
            action=""
            multiple
            :limit="2"
            :http-request="uploadFile"
            :before-upload="beforeUpload"
            :on-remove="handleRemove"
            :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
            <el-button v-show="showBtn<1||showBtn==3" size="small" type="info" @click="downFile()">点击下载</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="供应商" :required="true" v-show="showBtn<1||showBtn==3">
          <el-select v-model="form.supplier" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in supplier"
              :key="item.companyid"
              :label="item.company"
              :value="item.companyid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="0">下架</el-radio>
            <el-radio :label="1">上架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核状态" v-if="showBtn<1">
          <el-radio-group v-model="form.examine">
            <el-radio :label="0">待审核</el-radio>
            <el-radio :label="1">审核通过</el-radio>
            <el-radio :label="2">审核不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核原因" v-if="showBtn<1&&form.examine==2">
          <el-input type="textarea" v-model="form.examineMsg" maxlength="250" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button @click="saveGoods">保存</el-button>
        </el-form-item>
    </el-form>
  </div>
</el-card>
</template>
<script>
import goodsFunction from "@/api/goods"
import userFunction from "@/api/user"
import fileFunction from "@/api/file"
export default {
  data() {
    return {
      showBtn:sessionStorage.getItem('roleid'),
      supplier:[],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      dialogImageUrl:'',
      dialogVisible:false,
      imglist:[],
      fileList:[],
      uploaddata:{vcode:sessionStorage.getItem('token')},
      form:{
        id:'',
        catalogId:'',
        gcode:'',
        cgcode:'',
        title:'',
        keywords:'',
        scale:'',
        remark:'',
        taxRate:'',
        price:0.00,
        lprice:0.00,
        surplus:0,
        unit:'',
        supplier:'',
        validityTime:'',
        imglist:[],
        file:[],
        status:1,
        examine:'0',
        examineMsg:'',
        vcode:sessionStorage.getItem('token'),
      },
    };
  },
  methods:{
    getGoods(){
      goodsFunction.getGoods(this.form,this).then(res=>{
        this.form.id = res.id
        this.form.catalogId = res.catalogId
        this.form.gcode = res.gcode
        this.form.cgcode = res.cgcode
        this.form.title = res.title
        this.form.keywords = res.keywords
        this.form.remark = res.remark
        this.form.price = res.price
        this.form.lprice = res.lprice
        this.form.taxRate = res.taxRate
        this.form.scale = res.scale
        this.form.surplus = res.surplus
        this.form.supplier = res.supplier
        this.form.unit = res.unit
        this.form.validityTime = res.validity_time
        this.form.imglist = res.imglist
        this.form.file = res.file
        if(res.file){
          this.fileList.push({uid:res.file,name:res.file})
        }
        this.form.examine = res.examine
        this.form.examineMsg = res.examineMsg
        this.form.status = res.status
      })
    },
    saveGoods(){
      goodsFunction.saveGoods(this.form,this).then(res=>{
        this.$router.push('/home/goodsList')
      })
    },
    getSupplier(){
      userFunction.getSupplier({vcode:sessionStorage.getItem('token')},this).then((res) => {
        this.supplier = res
        this.getGoods()
      })
    },
    beforeUpload(file) {
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error('上传图片大小不能超过 50MB!');
      }
      return isLt50M;
    },
    handleRemove(){
      this.fileList = [];
      this.form.file = '';
    },
    uploadFile(params){
      const file = params.file,form = new FormData();
      form.append("file", file)
      form.append("vcode", sessionStorage.getItem('token'));
      fileFunction.uploadFile(form,this).then(res=>{
        this.fileList = []
        this.form.file=res.filename
        this.fileList.push({uid:res.filename,name:res.filename})
      })
    },
    downFile(){
      let a = document.createElement('a')
      a.href = this.form.file
      a.click()
    },
  },
  mounted () {
    this.form.id = this.$route.query.id
    this.getSupplier()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/goods/editGoods.vue